import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("p", null, " Når du skal nedrive eller renovere en bygning, er der en række forholdsregler, som du skal være opmærksom på. ", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, " I det følgende har vi angivet dem, som vi finder mest relevante i langt de fleste nedrivningsprojekter. Det er vigtigt at holde sig for øje, at denne gennemgang ikke er udtømmende, og der kan være flere forhold der er relevante for netop dit projekt. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "Generelt", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, " Når en bygning skal fjernes, kan arbejdet groft sagt inddeles i tre faser: Miljøkortlægning, sanering og nedrivning. ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Miljøkortlægningen", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, " Flere bygningsdele kan indeholde forskellige miljøproblematiske stoffer, som kan give problemer for dig eller dine omgivelser, hvis de ikke bliver håndteret korrekt. Derfor skal der laves en miljøkortlægning så disse findes, og man dermed ved hvilket arbejde, der skal udføres. For at sikre tidsplanen og økonomien i et nedrivningsprojekt, vil det typisk være en fordel med en tilbundsgående undersøgelse af alle bygningsdele fra start. Dette letter planlægningen af det videre forløb og minimerer risikoen for ubehagelige overraskelser. ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h2", null, "Sanering", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Før den egentlige nedrivning af bygningen startes, er det nødvendigt at alle de miljøproblematiske stoffer fjernes først. På den måde kan de rene materialer bagefter lettere sorteres og genbruges eller genanvendes. Denne proces vil i en typisk nedrivning være den mest tidskrævende, hvorfor det kan betale sig at give den ekstra opmærksomhed, så arbejdet kan planlægges bedst muligt. Der kan være anvendt PCB eller tungmetaller i maling på vægge og gulve. PCB skal renses af med specielle værnemidler, arbejdsmetoder og håndtering af affaldet. Desuden kan der være anvendt asbest i eksempelvis fliseklæb, forskellige gulvtyper og rørisolering. ", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Ved sanering af miljøproblematiske stoffer som bl.a. PCB, tungmetaller og asbest, er der en lang række krav, som bygherre skal overholde. Disse krav er beskrevet i lovgivningen og gengivet i flere renoverings- og nedrivningsvejledninger. Generelt skal det sikres, at der ikke er nogen medarbejdere, der bliver udsat for miljøproblematiske stoffer ligesom det skal undgås at stofferne spredes til omgivelserne. Nederst på denne side kan du finde en liste over relevant materialer, der indeholder en række krav og anvisninger. ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", null, "Nedrivning", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, " Efter endt sanering kan den egentlige nedrivning startes. Bygningen vil på dette tidspunkt være ren, og bygningsdelene til genbrug og genanvendelse skal nu sorteres og bringes videre i systemet. Dette arbejde vil typisk foretages af en gravemaskine med sortergrab. En erfaren maskinfører kan skille bygningen ad og sortere den i de forskellige fraktioner. Dette arbejde kræver, at der ikke må være personer til stede i bygningen, da det kan være forbundet med stor risiko ift. sammenstyrtning og nedfaldene genstande. ", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h2", null, "Plan for sikkerhed og sundhed", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("p", null, " Ved arbejde med stoffer og materialer der udgør en særlig fare for medarbejdernes sikkerhed eller sundhed, skal der udarbejdes en plan for sikkerhed og sundhed, hvilket er bygherres ansvar. Planen skal beskrive hvordan arbejdet kan planlægges og udføres sikkerheds- og sundhedsmæssigt fuldt forsvarligt. ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h2", null, "Liste over relevant materiale", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" Udgivelser fra "),
  /*#__PURE__*/_createElementVNode("i", null, "Nedrivning og Miljøsanering - en sektion i DI Dansk Byggeri")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("ul", null, [
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.danskindustri.dk/siteassets/di-byggeri/medlemsforeninger/nedrivning/stov-2021_2.korr.pdf",
      target: "_blank"
    }, "Den grå støvvejledning")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.danskindustri.dk/siteassets/di-byggeri/medlemsforeninger/nedrivning/pcb-2021_2.korr.pdf",
      target: "_blank"
    }, "Den gule PCB-vejledning")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.danskindustri.dk/siteassets/di-byggeri/medlemsforeninger/nedrivning/bly-2021_2.korr.pdf",
      target: "_blank"
    }, "Den blå blyvejledning")
  ]),
  /*#__PURE__*/_createElementVNode("li", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.danskindustri.dk/siteassets/di-byggeri/medlemsforeninger/nedrivning/asbest-2021_3.korr.pdf",
      target: "_blank"
    }, "Den grønne asbestvejledning")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PDFPage = _resolveComponent("PDFPage")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_PDFPage, {
      class: "PDFParadigmRemediation",
      contentClasses: 'PDFRichText',
      context: _ctx.context
    }, {
      sectionTitle: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.section) + ". Forholdsregler ved sanering og nedrivning", 1)
      ]),
      default: _withCtx(() => [
        _hoisted_1,
        _hoisted_2,
        _hoisted_3,
        _hoisted_4,
        _hoisted_5,
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9,
        _hoisted_10,
        _hoisted_11,
        _hoisted_12,
        _hoisted_13
      ]),
      _: 1
    }, 8, ["context"]),
    _createVNode(_component_PDFPage, {
      class: "PDFParadigmRemediation",
      contentClasses: 'PDFRichText',
      context: _ctx.context
    }, {
      default: _withCtx(() => [
        _hoisted_14,
        _hoisted_15,
        _hoisted_16
      ]),
      _: 1
    }, 8, ["context"])
  ], 64))
}